module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fto6Y"))).then(() => parcelRequire('d0iPb'));